import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
export const StagedSystem = props => {
    return (React.createElement(SvgIcon, Object.assign({}, props),
        React.createElement("path", { d: "M11,13 L11,21 L3,21 L3,13 L11,13 Z M21,13 L21,21 L13,21 L13,13 L21,13 Z M9,15 L5,15 L5,19 L9,19 L9,15 Z M19,15 L15,15 L15,19 L19,19 L19,15 Z M11,3 L11,11 L3,11 L3,3 L11,3 Z M21,3 L21,11 L13,11 L13,3 L21,3 Z M9,5 L5,5 L5,9 L9,9 L9,5 Z M19,5 L15,5 L15,9 L19,9 L19,5 Z" })));
};
export default StagedSystem;
